import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Komponenten")
], -1)
const _hoisted_5 = ["onClick", "title"]
const _hoisted_6 = { class: "mr-3" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "media-body align-self-center" }
const _hoisted_9 = { class: "font-weight-semibold" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "media-right align-self-center" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentGroups, (group, cIndex) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: cIndex,
          class: "media-list media-list-linked media-list-bordered"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, iIndex) => {
            return (_openBlock(), _createElementBlock("li", { key: iIndex }, [
              _createElementVNode("a", {
                class: "media cursor-pointer align-items-center p-1 p-lg-2",
                onClick: ($event: any) => (_ctx.getComponentFiles(item.id)),
                title: '# '+item.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.$getFileUrl+'?t=_cloud&id='+item.imgKomponente+'&_token='+_ctx.user.accessToken,
                    class: "rounded",
                    alt: "",
                    width: "42",
                    height: "42"
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.kurzname) + " (" + _toDisplayString(item.nummer) + ") ", 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.standort) + " - " + _toDisplayString(item.bemerkung), 1)
                ]),
                _hoisted_11
              ], 8, _hoisted_5)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}